import axios from 'axios';
import {CONSTANTS} from './constants';

export const apiMaintenance = axios.create({
  baseURL: CONSTANTS.maintenance_url,
});
